/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CalculateRestructuring } from '@coin/shared/core/util-models-v2';
import { CheckPermissionsForRestructuringDownload } from '@coin/shared/core/util-models-v2';
import { CreateRestructuringCommitmentExport } from '@coin/shared/core/util-models-v2';
import { CreateRestructuringLetterFile } from '@coin/shared/core/util-models-v2';
import { CreateRestructuringReportingExport } from '@coin/shared/core/util-models-v2';
import { CreateRestructuringRequestComment } from '@coin/shared/core/util-models-v2';
import { CreateRestructuringRequestReport } from '@coin/shared/core/util-models-v2';
import { GetInformationForLetterCreation } from '@coin/shared/core/util-models-v2';
import { PageOfActivityStreamOfString } from '@coin/shared/core/util-models-v2';
import { PageOfFieldItem } from '@coin/shared/core/util-models-v2';
import { PageOfRestructuringComment } from '@coin/shared/core/util-models-v2';
import { PageOfRestructuringEmployeeSnapshotLight } from '@coin/shared/core/util-models-v2';
import { PageOfRestructuringRequest } from '@coin/shared/core/util-models-v2';
import { PageOfRestructuringRequestReport } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { RestructuringCalculation } from '@coin/shared/core/util-models-v2';
import { RestructuringComment } from '@coin/shared/core/util-models-v2';
import { RestructuringDashboard } from '@coin/shared/core/util-models-v2';
import { RestructuringLetterCreationInfo } from '@coin/shared/core/util-models-v2';
import { RestructuringReportingHeader } from '@coin/shared/core/util-models-v2';
import { RestructuringRequest } from '@coin/shared/core/util-models-v2';
import { RestructuringRequestReport } from '@coin/shared/core/util-models-v2';
import { RestructuringSeasonLight } from '@coin/shared/core/util-models-v2';
import { SaveRestructuringCalculation } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfDocumentGenerationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { UpdateRestructuringRequest } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CalculateRestructuringCalculationParams {
  calculateRestructuring?: CalculateRestructuring;
}

export interface CheckPermissionsRestructuringRequestParams {
  checkPermissionsForRestructuringDownload?: CheckPermissionsForRestructuringDownload;
}

export interface CreateCalculationFileRestructuringRequestParams {
  requestId: string;
  createRestructuringLetterFile?: CreateRestructuringLetterFile;
}

export interface CreateCommentRestructuringRequestParams {
  requestId: string;
  createRestructuringRequestComment?: CreateRestructuringRequestComment;
}

export interface CreateExportRestructuringCommitmentParams {
  createRestructuringCommitmentExport?: CreateRestructuringCommitmentExport;
}

export interface CreateExportRestructuringReportingParams {
  createRestructuringReportingExport?: CreateRestructuringReportingExport;
}

export interface CreateLetterRestructuringRequestParams {
  requestId: string;
  createRestructuringLetterFile?: CreateRestructuringLetterFile;
}

export interface CreateReportItemRestructuringCommitmentParams {
  requestId: string;
  createRestructuringRequestReport?: CreateRestructuringRequestReport;
}

export interface CreateReportItemRestructuringReportingParams {
  requestId: string;
  createRestructuringRequestReport?: CreateRestructuringRequestReport;
}

export interface DeleteCommentRestructuringRequestParams {
  commentId: string;
  requestId: string;
}

export interface DeleteRestructuringRequestParams {
  requestId: string;
}

export interface GetActiveSeasonsEmployeeSnapshotsParams {
  employeeId: string;
  requestId?: string;
}

export interface GetActivityStreamForRequestRestructuringRequestParams {
  requestId: string;
  page?: number;
  size?: number;
}

export interface GetAdditionalAttributesRestructuringRequestParams {
  requestId: string;
  getInformationForLetterCreation?: GetInformationForLetterCreation;
}

export interface GetAssignmentFieldValuesByCountryRestructuringCommitmentParams {
  countryCode: string;
  assignmentId: string;
  searchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  queryAttributes?: { [key: string]: string };
  queryAttributeByName?: { [key: string]: string };
  queryAssignments?: { [key: string]: string };
  queryGid?: string;
  queryFirstName?: string;
  queryLastName?: string;
  queryFullName?: string;
  queryOrgCodeStartsWith?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryRequestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryFiscalYear?: Array<string>;
  queryAre?: Array<string>;
  queryCountry?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanId?: Array<string>;
  queryReportingDate?: string;
  queryUpdatedBy?: string;
  querySeasonId?: Array<string>;
  querySeasonTitle?: Array<string>;
  queryPlanTitle?: Array<string>;
  querySubState?: Array<string>;
  querySearchString?: string;
}

export interface GetAssignmentFieldValuesByCountryRestructuringReportingParams {
  countryCode: string;
  assignmentId: string;
  searchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  queryAttributes?: { [key: string]: string };
  queryAttributeByName?: { [key: string]: string };
  queryAssignments?: { [key: string]: string };
  queryGid?: string;
  queryFirstName?: string;
  queryLastName?: string;
  queryFullName?: string;
  queryOrgCodeStartsWith?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryRequestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryFiscalYear?: Array<string>;
  queryAre?: Array<string>;
  queryCountry?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanId?: Array<string>;
  queryReportingDate?: string;
  queryUpdatedBy?: string;
  querySeasonId?: Array<string>;
  querySeasonTitle?: Array<string>;
  queryPlanTitle?: Array<string>;
  querySubState?: Array<string>;
  querySearchString?: string;
}

export interface GetAssignmentFieldValuesBySeasonRestructuringCommitmentParams {
  seasonId: string;
  assignmentId: string;
  searchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  queryAttributes?: { [key: string]: string };
  queryAttributeByName?: { [key: string]: string };
  queryAssignments?: { [key: string]: string };
  queryGid?: string;
  queryFirstName?: string;
  queryLastName?: string;
  queryFullName?: string;
  queryOrgCodeStartsWith?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryRequestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryFiscalYear?: Array<string>;
  queryAre?: Array<string>;
  queryCountry?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanId?: Array<string>;
  queryReportingDate?: string;
  queryUpdatedBy?: string;
  querySeasonId?: Array<string>;
  querySeasonTitle?: Array<string>;
  queryPlanTitle?: Array<string>;
  querySubState?: Array<string>;
  querySearchString?: string;
}

export interface GetAssignmentFieldValuesBySeasonRestructuringReportingParams {
  seasonId: string;
  assignmentId: string;
  searchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  queryAttributes?: { [key: string]: string };
  queryAttributeByName?: { [key: string]: string };
  queryAssignments?: { [key: string]: string };
  queryGid?: string;
  queryFirstName?: string;
  queryLastName?: string;
  queryFullName?: string;
  queryOrgCodeStartsWith?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryRequestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryFiscalYear?: Array<string>;
  queryAre?: Array<string>;
  queryCountry?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanId?: Array<string>;
  queryReportingDate?: string;
  queryUpdatedBy?: string;
  querySeasonId?: Array<string>;
  querySeasonTitle?: Array<string>;
  queryPlanTitle?: Array<string>;
  querySubState?: Array<string>;
  querySearchString?: string;
}

export interface GetCalculationByRequestRestructuringRequestParams {
  requestId: string;
}

export interface GetDashboardRestructuringCommitmentParams {
  countryCode: string;
  attributes?: { [key: string]: string };
  attributeByName?: { [key: string]: string };
  assignments?: { [key: string]: string };
  gid?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  orgCodeStartsWith?: string;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  requestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  fiscalYear?: Array<string>;
  are?: Array<string>;
  country?: Array<string>;
  orgCode?: Array<string>;
  planId?: Array<string>;
  reportingDate?: string;
  updatedBy?: string;
  seasonId?: Array<string>;
  seasonTitle?: Array<string>;
  planTitle?: Array<string>;
  subState?: Array<string>;
  searchString?: string;
}

export interface GetDashboardRestructuringReportingParams {
  countryCode: string;
  attributes?: { [key: string]: string };
  attributeByName?: { [key: string]: string };
  assignments?: { [key: string]: string };
  gid?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  orgCodeStartsWith?: string;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  requestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  fiscalYear?: Array<string>;
  are?: Array<string>;
  country?: Array<string>;
  orgCode?: Array<string>;
  planId?: Array<string>;
  reportingDate?: string;
  updatedBy?: string;
  seasonId?: Array<string>;
  seasonTitle?: Array<string>;
  planTitle?: Array<string>;
  subState?: Array<string>;
  searchString?: string;
}

export interface GetDashboardRestructuringRequestParams {
  searchString?: string;
  fiscalYear?: string;
  queryCountry?: Array<string>;
  queryAre?: Array<string>;
  querySeasonId?: Array<string>;
  queryPlanId?: Array<string>;
  queryState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryLineManagerGid?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryFiscalYear?: Array<string>;
  queryCompanyManagerGid?: Array<string>;
  queryCreatedByGid?: Array<string>;
}

export interface GetFieldValuesByCountryRestructuringCommitmentParams {
  countryCode: string;
  fieldName: string;
  searchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  queryAttributes?: { [key: string]: string };
  queryAttributeByName?: { [key: string]: string };
  queryAssignments?: { [key: string]: string };
  queryGid?: string;
  queryFirstName?: string;
  queryLastName?: string;
  queryFullName?: string;
  queryOrgCodeStartsWith?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryRequestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryFiscalYear?: Array<string>;
  queryAre?: Array<string>;
  queryCountry?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanId?: Array<string>;
  queryReportingDate?: string;
  queryUpdatedBy?: string;
  querySeasonId?: Array<string>;
  querySeasonTitle?: Array<string>;
  queryPlanTitle?: Array<string>;
  querySubState?: Array<string>;
  querySearchString?: string;
}

export interface GetFieldValuesByCountryRestructuringReportingParams {
  countryCode: string;
  fieldName: string;
  searchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  queryAttributes?: { [key: string]: string };
  queryAttributeByName?: { [key: string]: string };
  queryAssignments?: { [key: string]: string };
  queryGid?: string;
  queryFirstName?: string;
  queryLastName?: string;
  queryFullName?: string;
  queryOrgCodeStartsWith?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryRequestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryFiscalYear?: Array<string>;
  queryAre?: Array<string>;
  queryCountry?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanId?: Array<string>;
  queryReportingDate?: string;
  queryUpdatedBy?: string;
  querySeasonId?: Array<string>;
  querySeasonTitle?: Array<string>;
  queryPlanTitle?: Array<string>;
  querySubState?: Array<string>;
  querySearchString?: string;
}

export interface GetFieldValuesBySeasonRestructuringCommitmentParams {
  seasonId: string;
  fieldName: string;
  searchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  queryAttributes?: { [key: string]: string };
  queryAttributeByName?: { [key: string]: string };
  queryAssignments?: { [key: string]: string };
  queryGid?: string;
  queryFirstName?: string;
  queryLastName?: string;
  queryFullName?: string;
  queryOrgCodeStartsWith?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryRequestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryFiscalYear?: Array<string>;
  queryAre?: Array<string>;
  queryCountry?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanId?: Array<string>;
  queryReportingDate?: string;
  queryUpdatedBy?: string;
  querySeasonId?: Array<string>;
  querySeasonTitle?: Array<string>;
  queryPlanTitle?: Array<string>;
  querySubState?: Array<string>;
  querySearchString?: string;
}

export interface GetFieldValuesBySeasonRestructuringReportingParams {
  seasonId: string;
  fieldName: string;
  searchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  queryAttributes?: { [key: string]: string };
  queryAttributeByName?: { [key: string]: string };
  queryAssignments?: { [key: string]: string };
  queryGid?: string;
  queryFirstName?: string;
  queryLastName?: string;
  queryFullName?: string;
  queryOrgCodeStartsWith?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryRequestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryFiscalYear?: Array<string>;
  queryAre?: Array<string>;
  queryCountry?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanId?: Array<string>;
  queryReportingDate?: string;
  queryUpdatedBy?: string;
  querySeasonId?: Array<string>;
  querySeasonTitle?: Array<string>;
  queryPlanTitle?: Array<string>;
  querySubState?: Array<string>;
  querySearchString?: string;
}

export interface GetHeadersRestructuringCommitmentParams {
  countryCode: string;
}

export interface GetHeadersRestructuringReportingParams {
  countryCode: string;
}

export interface GetItemsByCountryRestructuringCommitmentParams {
  countryCode: string;
  searchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  queryAttributes?: { [key: string]: string };
  queryAttributeByName?: { [key: string]: string };
  queryAssignments?: { [key: string]: string };
  queryGid?: string;
  queryFirstName?: string;
  queryLastName?: string;
  queryFullName?: string;
  queryOrgCodeStartsWith?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryRequestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryFiscalYear?: Array<string>;
  queryAre?: Array<string>;
  queryCountry?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanId?: Array<string>;
  queryReportingDate?: string;
  queryUpdatedBy?: string;
  querySeasonId?: Array<string>;
  querySeasonTitle?: Array<string>;
  queryPlanTitle?: Array<string>;
  querySubState?: Array<string>;
  querySearchString?: string;
}

export interface GetItemsByCountryRestructuringReportingParams {
  countryCode: string;
  searchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  queryAttributes?: { [key: string]: string };
  queryAttributeByName?: { [key: string]: string };
  queryAssignments?: { [key: string]: string };
  queryGid?: string;
  queryFirstName?: string;
  queryLastName?: string;
  queryFullName?: string;
  queryOrgCodeStartsWith?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryRequestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryFiscalYear?: Array<string>;
  queryAre?: Array<string>;
  queryCountry?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanId?: Array<string>;
  queryReportingDate?: string;
  queryUpdatedBy?: string;
  querySeasonId?: Array<string>;
  querySeasonTitle?: Array<string>;
  queryPlanTitle?: Array<string>;
  querySubState?: Array<string>;
  querySearchString?: string;
}

export interface GetItemsByRequestRestructuringCommitmentParams {
  requestId: string;
  queryAttributes?: { [key: string]: string };
  queryAttributeByName?: { [key: string]: string };
  queryAssignments?: { [key: string]: string };
  queryGid?: string;
  queryFirstName?: string;
  queryLastName?: string;
  queryFullName?: string;
  queryOrgCodeStartsWith?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryRequestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryFiscalYear?: Array<string>;
  queryAre?: Array<string>;
  queryCountry?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanId?: Array<string>;
  queryReportingDate?: string;
  queryUpdatedBy?: string;
  querySeasonId?: Array<string>;
  querySeasonTitle?: Array<string>;
  queryPlanTitle?: Array<string>;
  querySubState?: Array<string>;
  querySearchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface GetItemsByRequestRestructuringReportingParams {
  requestId: string;
  queryAttributes?: { [key: string]: string };
  queryAttributeByName?: { [key: string]: string };
  queryAssignments?: { [key: string]: string };
  queryGid?: string;
  queryFirstName?: string;
  queryLastName?: string;
  queryFullName?: string;
  queryOrgCodeStartsWith?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryRequestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryFiscalYear?: Array<string>;
  queryAre?: Array<string>;
  queryCountry?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanId?: Array<string>;
  queryReportingDate?: string;
  queryUpdatedBy?: string;
  querySeasonId?: Array<string>;
  querySeasonTitle?: Array<string>;
  queryPlanTitle?: Array<string>;
  querySubState?: Array<string>;
  querySearchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface GetItemsBySeasonRestructuringCommitmentParams {
  seasonId: string;
  searchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  queryAttributes?: { [key: string]: string };
  queryAttributeByName?: { [key: string]: string };
  queryAssignments?: { [key: string]: string };
  queryGid?: string;
  queryFirstName?: string;
  queryLastName?: string;
  queryFullName?: string;
  queryOrgCodeStartsWith?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryRequestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryFiscalYear?: Array<string>;
  queryAre?: Array<string>;
  queryCountry?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanId?: Array<string>;
  queryReportingDate?: string;
  queryUpdatedBy?: string;
  querySeasonId?: Array<string>;
  querySeasonTitle?: Array<string>;
  queryPlanTitle?: Array<string>;
  querySubState?: Array<string>;
  querySearchString?: string;
}

export interface GetItemsBySeasonRestructuringReportingParams {
  seasonId: string;
  searchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  queryAttributes?: { [key: string]: string };
  queryAttributeByName?: { [key: string]: string };
  queryAssignments?: { [key: string]: string };
  queryGid?: string;
  queryFirstName?: string;
  queryLastName?: string;
  queryFullName?: string;
  queryOrgCodeStartsWith?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryRequestState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryFiscalYear?: Array<string>;
  queryAre?: Array<string>;
  queryCountry?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanId?: Array<string>;
  queryReportingDate?: string;
  queryUpdatedBy?: string;
  querySeasonId?: Array<string>;
  querySeasonTitle?: Array<string>;
  queryPlanTitle?: Array<string>;
  querySubState?: Array<string>;
  querySearchString?: string;
}

export interface GetRequestRestructuringRequestParams {
  requestId: string;
}

export interface QueryCommentsRestructuringRequestParams {
  requestId: string;
  page?: number;
  size?: number;
}

export interface QueryFieldValueRestructuringRequestParams {
  fieldName: string;
  searchString?: string;
  fiscalYear?: string;
  queryCountry?: Array<string>;
  queryAre?: Array<string>;
  querySeasonId?: Array<string>;
  queryPlanId?: Array<string>;
  queryState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryLineManagerGid?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryFiscalYear?: Array<string>;
  queryCompanyManagerGid?: Array<string>;
  queryCreatedByGid?: Array<string>;
  page?: number;
  size?: number;
}

export interface QueryFieldValueWithIdRestructuringRequestParams {
  fieldName: string;
  searchString?: string;
  fiscalYear?: string;
  queryCountry?: Array<string>;
  queryAre?: Array<string>;
  querySeasonId?: Array<string>;
  queryPlanId?: Array<string>;
  queryState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryLineManagerGid?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryFiscalYear?: Array<string>;
  queryCompanyManagerGid?: Array<string>;
  queryCreatedByGid?: Array<string>;
  page?: number;
  size?: number;
}

export interface QueryRestructuringRequestParams {
  searchString?: string;
  fiscalYear?: string;
  queryCountry?: Array<string>;
  queryAre?: Array<string>;
  querySeasonId?: Array<string>;
  queryPlanId?: Array<string>;
  queryState?: Array<'Draft' | 'Monitoring' | 'Accepted' | 'Rejected' | 'Published'>;
  queryLineManagerGid?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryFiscalYear?: Array<string>;
  queryCompanyManagerGid?: Array<string>;
  queryCreatedByGid?: Array<string>;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface RestructuringCustomerQueryAttributesParams {
  id: string;
}

export interface RestructuringCustomerQueryEmployeeSnapshotsParams {
  searchString?: string;
  includeManagerInformation?: boolean;
  includeAttributes?: boolean;
  includeLetter?: boolean;
  queryCountry?: Array<string>;
  queryLegalEntity?: Array<string>;
  queryContractStatus?: Array<string>;
  queryGid?: string;
  queryFullName?: string;
  queryOrgCode?: string;
  queryAttributes?: { [key: string]: string };
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SaveCalculationRestructuringCalculationParams {
  saveRestructuringCalculation?: SaveRestructuringCalculation;
}

export interface UpdateRequestRestructuringRequestParams {
  updateRestructuringRequest?: UpdateRestructuringRequest;
}

@Injectable({
  providedIn: 'root'
})
export class RestructuringCustomerService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public calculateRestructuringCalculation(
    requestParameters?: CalculateRestructuringCalculationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RestructuringCalculation>;
  public calculateRestructuringCalculation(
    requestParameters?: CalculateRestructuringCalculationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RestructuringCalculation>>;
  public calculateRestructuringCalculation(
    requestParameters?: CalculateRestructuringCalculationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RestructuringCalculation>>;
  public calculateRestructuringCalculation(
    requestParameters?: CalculateRestructuringCalculationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/restructuring/customer/v1/calculation/simulate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.calculateRestructuring,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public checkPermissionsRestructuringRequest(
    requestParameters?: CheckPermissionsRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public checkPermissionsRestructuringRequest(
    requestParameters?: CheckPermissionsRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public checkPermissionsRestructuringRequest(
    requestParameters?: CheckPermissionsRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public checkPermissionsRestructuringRequest(
    requestParameters?: CheckPermissionsRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/restructuring/customer/v1/requests/check-permissions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.checkPermissionsForRestructuringDownload,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createCalculationFileRestructuringRequest(
    requestParameters?: CreateCalculationFileRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfDocumentGenerationMetadata>;
  public createCalculationFileRestructuringRequest(
    requestParameters?: CreateCalculationFileRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfDocumentGenerationMetadata>>;
  public createCalculationFileRestructuringRequest(
    requestParameters?: CreateCalculationFileRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfDocumentGenerationMetadata>>;
  public createCalculationFileRestructuringRequest(
    requestParameters?: CreateCalculationFileRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    const requestId = requestParameters?.requestId;
    this.checkRequired('createCalculationFileRestructuringRequest', { requestId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/restructuring/customer/v1/requests/${this.configuration.encodeParam({ name: 'requestId', value: requestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/calculation-file`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createRestructuringLetterFile,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createCommentRestructuringRequest(
    requestParameters?: CreateCommentRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RestructuringComment>;
  public createCommentRestructuringRequest(
    requestParameters?: CreateCommentRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RestructuringComment>>;
  public createCommentRestructuringRequest(
    requestParameters?: CreateCommentRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RestructuringComment>>;
  public createCommentRestructuringRequest(
    requestParameters?: CreateCommentRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    const requestId = requestParameters?.requestId;
    this.checkRequired('createCommentRestructuringRequest', { requestId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/restructuring/customer/v1/requests/${this.configuration.encodeParam({ name: 'requestId', value: requestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createRestructuringRequestComment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createExportRestructuringCommitment(
    requestParameters?: CreateExportRestructuringCommitmentParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public createExportRestructuringCommitment(
    requestParameters?: CreateExportRestructuringCommitmentParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public createExportRestructuringCommitment(
    requestParameters?: CreateExportRestructuringCommitmentParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public createExportRestructuringCommitment(
    requestParameters?: CreateExportRestructuringCommitmentParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/restructuring/customer/v1/commitment/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createRestructuringCommitmentExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createExportRestructuringReporting(
    requestParameters?: CreateExportRestructuringReportingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public createExportRestructuringReporting(
    requestParameters?: CreateExportRestructuringReportingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public createExportRestructuringReporting(
    requestParameters?: CreateExportRestructuringReportingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public createExportRestructuringReporting(
    requestParameters?: CreateExportRestructuringReportingParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/restructuring/customer/v1/reporting/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createRestructuringReportingExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createLetterRestructuringRequest(
    requestParameters?: CreateLetterRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfDocumentGenerationMetadata>;
  public createLetterRestructuringRequest(
    requestParameters?: CreateLetterRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfDocumentGenerationMetadata>>;
  public createLetterRestructuringRequest(
    requestParameters?: CreateLetterRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfDocumentGenerationMetadata>>;
  public createLetterRestructuringRequest(
    requestParameters?: CreateLetterRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    const requestId = requestParameters?.requestId;
    this.checkRequired('createLetterRestructuringRequest', { requestId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/restructuring/customer/v1/requests/${this.configuration.encodeParam({ name: 'requestId', value: requestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/letter`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createRestructuringLetterFile,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createReportItemRestructuringCommitment(
    requestParameters?: CreateReportItemRestructuringCommitmentParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RestructuringRequestReport>;
  public createReportItemRestructuringCommitment(
    requestParameters?: CreateReportItemRestructuringCommitmentParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RestructuringRequestReport>>;
  public createReportItemRestructuringCommitment(
    requestParameters?: CreateReportItemRestructuringCommitmentParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RestructuringRequestReport>>;
  public createReportItemRestructuringCommitment(
    requestParameters?: CreateReportItemRestructuringCommitmentParams,
    ...args: RequestArgs
  ): Observable<any> {
    const requestId = requestParameters?.requestId;
    this.checkRequired('createReportItemRestructuringCommitment', { requestId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/restructuring/customer/v1/commitment/requests/${this.configuration.encodeParam({ name: 'requestId', value: requestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createRestructuringRequestReport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createReportItemRestructuringReporting(
    requestParameters?: CreateReportItemRestructuringReportingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RestructuringRequestReport>;
  public createReportItemRestructuringReporting(
    requestParameters?: CreateReportItemRestructuringReportingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RestructuringRequestReport>>;
  public createReportItemRestructuringReporting(
    requestParameters?: CreateReportItemRestructuringReportingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RestructuringRequestReport>>;
  public createReportItemRestructuringReporting(
    requestParameters?: CreateReportItemRestructuringReportingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const requestId = requestParameters?.requestId;
    this.checkRequired('createReportItemRestructuringReporting', { requestId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/restructuring/customer/v1/reporting/requests/${this.configuration.encodeParam({ name: 'requestId', value: requestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createRestructuringRequestReport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteCommentRestructuringRequest(
    requestParameters?: DeleteCommentRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteCommentRestructuringRequest(
    requestParameters?: DeleteCommentRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteCommentRestructuringRequest(
    requestParameters?: DeleteCommentRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteCommentRestructuringRequest(
    requestParameters?: DeleteCommentRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    const commentId = requestParameters?.commentId;
    const requestId = requestParameters?.requestId;
    this.checkRequired('deleteCommentRestructuringRequest', { commentId, requestId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/restructuring/customer/v1/requests/${this.configuration.encodeParam({ name: 'requestId', value: requestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/comments/${this.configuration.encodeParam({ name: 'commentId', value: commentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteRestructuringRequest(
    requestParameters?: DeleteRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public deleteRestructuringRequest(
    requestParameters?: DeleteRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public deleteRestructuringRequest(
    requestParameters?: DeleteRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public deleteRestructuringRequest(
    requestParameters?: DeleteRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    const requestId = requestParameters?.requestId;
    this.checkRequired('deleteRestructuringRequest', { requestId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/restructuring/customer/v1/requests/${this.configuration.encodeParam({ name: 'requestId', value: requestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getActiveSeasonsEmployeeSnapshots(
    requestParameters?: GetActiveSeasonsEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<RestructuringSeasonLight>>;
  public getActiveSeasonsEmployeeSnapshots(
    requestParameters?: GetActiveSeasonsEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<RestructuringSeasonLight>>>;
  public getActiveSeasonsEmployeeSnapshots(
    requestParameters?: GetActiveSeasonsEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<RestructuringSeasonLight>>>;
  public getActiveSeasonsEmployeeSnapshots(
    requestParameters?: GetActiveSeasonsEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getActiveSeasonsEmployeeSnapshots', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/seasons`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { requestId: requestParameters?.requestId }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getActivityStreamForRequestRestructuringRequest(
    requestParameters?: GetActivityStreamForRequestRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfActivityStreamOfString>;
  public getActivityStreamForRequestRestructuringRequest(
    requestParameters?: GetActivityStreamForRequestRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfActivityStreamOfString>>;
  public getActivityStreamForRequestRestructuringRequest(
    requestParameters?: GetActivityStreamForRequestRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfActivityStreamOfString>>;
  public getActivityStreamForRequestRestructuringRequest(
    requestParameters?: GetActivityStreamForRequestRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    const requestId = requestParameters?.requestId;
    this.checkRequired('getActivityStreamForRequestRestructuringRequest', { requestId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/requests/${this.configuration.encodeParam({ name: 'requestId', value: requestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/activity-stream`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAdditionalAttributesRestructuringRequest(
    requestParameters?: GetAdditionalAttributesRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RestructuringLetterCreationInfo>;
  public getAdditionalAttributesRestructuringRequest(
    requestParameters?: GetAdditionalAttributesRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RestructuringLetterCreationInfo>>;
  public getAdditionalAttributesRestructuringRequest(
    requestParameters?: GetAdditionalAttributesRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RestructuringLetterCreationInfo>>;
  public getAdditionalAttributesRestructuringRequest(
    requestParameters?: GetAdditionalAttributesRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    const requestId = requestParameters?.requestId;
    this.checkRequired('getAdditionalAttributesRestructuringRequest', { requestId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/restructuring/customer/v1/requests/${this.configuration.encodeParam({ name: 'requestId', value: requestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/letter-creation/information`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.getInformationForLetterCreation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAssignmentFieldValuesByCountryRestructuringCommitment(
    requestParameters?: GetAssignmentFieldValuesByCountryRestructuringCommitmentParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public getAssignmentFieldValuesByCountryRestructuringCommitment(
    requestParameters?: GetAssignmentFieldValuesByCountryRestructuringCommitmentParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public getAssignmentFieldValuesByCountryRestructuringCommitment(
    requestParameters?: GetAssignmentFieldValuesByCountryRestructuringCommitmentParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public getAssignmentFieldValuesByCountryRestructuringCommitment(
    requestParameters?: GetAssignmentFieldValuesByCountryRestructuringCommitmentParams,
    ...args: RequestArgs
  ): Observable<any> {
    const countryCode = requestParameters?.countryCode;
    const assignmentId = requestParameters?.assignmentId;
    this.checkRequired('getAssignmentFieldValuesByCountryRestructuringCommitment', { countryCode, assignmentId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/commitment/country/${this.configuration.encodeParam({ name: 'countryCode', value: countryCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/assignment-field-values/${this.configuration.encodeParam({ name: 'assignmentId', value: assignmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Query.Attributes': requestParameters?.queryAttributes,
        'Query.AttributeByName': requestParameters?.queryAttributeByName,
        'Query.Assignments': requestParameters?.queryAssignments,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.RequestState': requestParameters?.queryRequestState,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.Are': requestParameters?.queryAre,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.ReportingDate': requestParameters?.queryReportingDate,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.SeasonTitle': requestParameters?.querySeasonTitle,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.SubState': requestParameters?.querySubState,
        'Query.SearchString': requestParameters?.querySearchString
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAssignmentFieldValuesByCountryRestructuringReporting(
    requestParameters?: GetAssignmentFieldValuesByCountryRestructuringReportingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public getAssignmentFieldValuesByCountryRestructuringReporting(
    requestParameters?: GetAssignmentFieldValuesByCountryRestructuringReportingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public getAssignmentFieldValuesByCountryRestructuringReporting(
    requestParameters?: GetAssignmentFieldValuesByCountryRestructuringReportingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public getAssignmentFieldValuesByCountryRestructuringReporting(
    requestParameters?: GetAssignmentFieldValuesByCountryRestructuringReportingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const countryCode = requestParameters?.countryCode;
    const assignmentId = requestParameters?.assignmentId;
    this.checkRequired('getAssignmentFieldValuesByCountryRestructuringReporting', { countryCode, assignmentId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/reporting/country/${this.configuration.encodeParam({ name: 'countryCode', value: countryCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/assignment-field-values/${this.configuration.encodeParam({ name: 'assignmentId', value: assignmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Query.Attributes': requestParameters?.queryAttributes,
        'Query.AttributeByName': requestParameters?.queryAttributeByName,
        'Query.Assignments': requestParameters?.queryAssignments,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.RequestState': requestParameters?.queryRequestState,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.Are': requestParameters?.queryAre,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.ReportingDate': requestParameters?.queryReportingDate,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.SeasonTitle': requestParameters?.querySeasonTitle,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.SubState': requestParameters?.querySubState,
        'Query.SearchString': requestParameters?.querySearchString
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAssignmentFieldValuesBySeasonRestructuringCommitment(
    requestParameters?: GetAssignmentFieldValuesBySeasonRestructuringCommitmentParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public getAssignmentFieldValuesBySeasonRestructuringCommitment(
    requestParameters?: GetAssignmentFieldValuesBySeasonRestructuringCommitmentParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public getAssignmentFieldValuesBySeasonRestructuringCommitment(
    requestParameters?: GetAssignmentFieldValuesBySeasonRestructuringCommitmentParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public getAssignmentFieldValuesBySeasonRestructuringCommitment(
    requestParameters?: GetAssignmentFieldValuesBySeasonRestructuringCommitmentParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const assignmentId = requestParameters?.assignmentId;
    this.checkRequired('getAssignmentFieldValuesBySeasonRestructuringCommitment', { seasonId, assignmentId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/commitment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/assignment-field-values/${this.configuration.encodeParam({ name: 'assignmentId', value: assignmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Query.Attributes': requestParameters?.queryAttributes,
        'Query.AttributeByName': requestParameters?.queryAttributeByName,
        'Query.Assignments': requestParameters?.queryAssignments,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.RequestState': requestParameters?.queryRequestState,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.Are': requestParameters?.queryAre,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.ReportingDate': requestParameters?.queryReportingDate,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.SeasonTitle': requestParameters?.querySeasonTitle,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.SubState': requestParameters?.querySubState,
        'Query.SearchString': requestParameters?.querySearchString
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAssignmentFieldValuesBySeasonRestructuringReporting(
    requestParameters?: GetAssignmentFieldValuesBySeasonRestructuringReportingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public getAssignmentFieldValuesBySeasonRestructuringReporting(
    requestParameters?: GetAssignmentFieldValuesBySeasonRestructuringReportingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public getAssignmentFieldValuesBySeasonRestructuringReporting(
    requestParameters?: GetAssignmentFieldValuesBySeasonRestructuringReportingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public getAssignmentFieldValuesBySeasonRestructuringReporting(
    requestParameters?: GetAssignmentFieldValuesBySeasonRestructuringReportingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const assignmentId = requestParameters?.assignmentId;
    this.checkRequired('getAssignmentFieldValuesBySeasonRestructuringReporting', { seasonId, assignmentId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/reporting/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/assignment-field-values/${this.configuration.encodeParam({ name: 'assignmentId', value: assignmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Query.Attributes': requestParameters?.queryAttributes,
        'Query.AttributeByName': requestParameters?.queryAttributeByName,
        'Query.Assignments': requestParameters?.queryAssignments,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.RequestState': requestParameters?.queryRequestState,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.Are': requestParameters?.queryAre,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.ReportingDate': requestParameters?.queryReportingDate,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.SeasonTitle': requestParameters?.querySeasonTitle,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.SubState': requestParameters?.querySubState,
        'Query.SearchString': requestParameters?.querySearchString
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCalculationByRequestRestructuringRequest(
    requestParameters?: GetCalculationByRequestRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RestructuringCalculation>;
  public getCalculationByRequestRestructuringRequest(
    requestParameters?: GetCalculationByRequestRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RestructuringCalculation>>;
  public getCalculationByRequestRestructuringRequest(
    requestParameters?: GetCalculationByRequestRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RestructuringCalculation>>;
  public getCalculationByRequestRestructuringRequest(
    requestParameters?: GetCalculationByRequestRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    const requestId = requestParameters?.requestId;
    this.checkRequired('getCalculationByRequestRestructuringRequest', { requestId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/requests/${this.configuration.encodeParam({ name: 'requestId', value: requestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/calculation`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDashboardRestructuringCommitment(
    requestParameters?: GetDashboardRestructuringCommitmentParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RestructuringDashboard>;
  public getDashboardRestructuringCommitment(
    requestParameters?: GetDashboardRestructuringCommitmentParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RestructuringDashboard>>;
  public getDashboardRestructuringCommitment(
    requestParameters?: GetDashboardRestructuringCommitmentParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RestructuringDashboard>>;
  public getDashboardRestructuringCommitment(
    requestParameters?: GetDashboardRestructuringCommitmentParams,
    ...args: RequestArgs
  ): Observable<any> {
    const countryCode = requestParameters?.countryCode;
    this.checkRequired('getDashboardRestructuringCommitment', { countryCode });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/commitment/dashboard/${this.configuration.encodeParam({ name: 'countryCode', value: countryCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Attributes: requestParameters?.attributes,
        AttributeByName: requestParameters?.attributeByName,
        Assignments: requestParameters?.assignments,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        FullName: requestParameters?.fullName,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        ContractStatus: requestParameters?.contractStatus,
        RequestState: requestParameters?.requestState,
        FiscalYear: requestParameters?.fiscalYear,
        Are: requestParameters?.are,
        Country: requestParameters?.country,
        OrgCode: requestParameters?.orgCode,
        PlanId: requestParameters?.planId,
        ReportingDate: requestParameters?.reportingDate,
        UpdatedBy: requestParameters?.updatedBy,
        SeasonId: requestParameters?.seasonId,
        SeasonTitle: requestParameters?.seasonTitle,
        PlanTitle: requestParameters?.planTitle,
        SubState: requestParameters?.subState,
        SearchString: requestParameters?.searchString
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDashboardRestructuringReporting(
    requestParameters?: GetDashboardRestructuringReportingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RestructuringDashboard>;
  public getDashboardRestructuringReporting(
    requestParameters?: GetDashboardRestructuringReportingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RestructuringDashboard>>;
  public getDashboardRestructuringReporting(
    requestParameters?: GetDashboardRestructuringReportingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RestructuringDashboard>>;
  public getDashboardRestructuringReporting(
    requestParameters?: GetDashboardRestructuringReportingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const countryCode = requestParameters?.countryCode;
    this.checkRequired('getDashboardRestructuringReporting', { countryCode });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/reporting/dashboard/${this.configuration.encodeParam({ name: 'countryCode', value: countryCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Attributes: requestParameters?.attributes,
        AttributeByName: requestParameters?.attributeByName,
        Assignments: requestParameters?.assignments,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        FullName: requestParameters?.fullName,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        ContractStatus: requestParameters?.contractStatus,
        RequestState: requestParameters?.requestState,
        FiscalYear: requestParameters?.fiscalYear,
        Are: requestParameters?.are,
        Country: requestParameters?.country,
        OrgCode: requestParameters?.orgCode,
        PlanId: requestParameters?.planId,
        ReportingDate: requestParameters?.reportingDate,
        UpdatedBy: requestParameters?.updatedBy,
        SeasonId: requestParameters?.seasonId,
        SeasonTitle: requestParameters?.seasonTitle,
        PlanTitle: requestParameters?.planTitle,
        SubState: requestParameters?.subState,
        SearchString: requestParameters?.searchString
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDashboardRestructuringRequest(
    requestParameters?: GetDashboardRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RestructuringDashboard>;
  public getDashboardRestructuringRequest(
    requestParameters?: GetDashboardRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RestructuringDashboard>>;
  public getDashboardRestructuringRequest(
    requestParameters?: GetDashboardRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RestructuringDashboard>>;
  public getDashboardRestructuringRequest(
    requestParameters?: GetDashboardRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/requests/dashboard`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        FiscalYear: requestParameters?.fiscalYear,
        'Query.Country': requestParameters?.queryCountry,
        'Query.Are': requestParameters?.queryAre,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.State': requestParameters?.queryState,
        'Query.LineManagerGid': requestParameters?.queryLineManagerGid,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.CompanyManagerGid': requestParameters?.queryCompanyManagerGid,
        'Query.CreatedByGid': requestParameters?.queryCreatedByGid
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getFieldValuesByCountryRestructuringCommitment(
    requestParameters?: GetFieldValuesByCountryRestructuringCommitmentParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public getFieldValuesByCountryRestructuringCommitment(
    requestParameters?: GetFieldValuesByCountryRestructuringCommitmentParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public getFieldValuesByCountryRestructuringCommitment(
    requestParameters?: GetFieldValuesByCountryRestructuringCommitmentParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public getFieldValuesByCountryRestructuringCommitment(
    requestParameters?: GetFieldValuesByCountryRestructuringCommitmentParams,
    ...args: RequestArgs
  ): Observable<any> {
    const countryCode = requestParameters?.countryCode;
    const fieldName = requestParameters?.fieldName;
    this.checkRequired('getFieldValuesByCountryRestructuringCommitment', { countryCode, fieldName });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/commitment/country/${this.configuration.encodeParam({ name: 'countryCode', value: countryCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Query.Attributes': requestParameters?.queryAttributes,
        'Query.AttributeByName': requestParameters?.queryAttributeByName,
        'Query.Assignments': requestParameters?.queryAssignments,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.RequestState': requestParameters?.queryRequestState,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.Are': requestParameters?.queryAre,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.ReportingDate': requestParameters?.queryReportingDate,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.SeasonTitle': requestParameters?.querySeasonTitle,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.SubState': requestParameters?.querySubState,
        'Query.SearchString': requestParameters?.querySearchString
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getFieldValuesByCountryRestructuringReporting(
    requestParameters?: GetFieldValuesByCountryRestructuringReportingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public getFieldValuesByCountryRestructuringReporting(
    requestParameters?: GetFieldValuesByCountryRestructuringReportingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public getFieldValuesByCountryRestructuringReporting(
    requestParameters?: GetFieldValuesByCountryRestructuringReportingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public getFieldValuesByCountryRestructuringReporting(
    requestParameters?: GetFieldValuesByCountryRestructuringReportingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const countryCode = requestParameters?.countryCode;
    const fieldName = requestParameters?.fieldName;
    this.checkRequired('getFieldValuesByCountryRestructuringReporting', { countryCode, fieldName });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/reporting/country/${this.configuration.encodeParam({ name: 'countryCode', value: countryCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Query.Attributes': requestParameters?.queryAttributes,
        'Query.AttributeByName': requestParameters?.queryAttributeByName,
        'Query.Assignments': requestParameters?.queryAssignments,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.RequestState': requestParameters?.queryRequestState,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.Are': requestParameters?.queryAre,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.ReportingDate': requestParameters?.queryReportingDate,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.SeasonTitle': requestParameters?.querySeasonTitle,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.SubState': requestParameters?.querySubState,
        'Query.SearchString': requestParameters?.querySearchString
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getFieldValuesBySeasonRestructuringCommitment(
    requestParameters?: GetFieldValuesBySeasonRestructuringCommitmentParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public getFieldValuesBySeasonRestructuringCommitment(
    requestParameters?: GetFieldValuesBySeasonRestructuringCommitmentParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public getFieldValuesBySeasonRestructuringCommitment(
    requestParameters?: GetFieldValuesBySeasonRestructuringCommitmentParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public getFieldValuesBySeasonRestructuringCommitment(
    requestParameters?: GetFieldValuesBySeasonRestructuringCommitmentParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const fieldName = requestParameters?.fieldName;
    this.checkRequired('getFieldValuesBySeasonRestructuringCommitment', { seasonId, fieldName });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/commitment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Query.Attributes': requestParameters?.queryAttributes,
        'Query.AttributeByName': requestParameters?.queryAttributeByName,
        'Query.Assignments': requestParameters?.queryAssignments,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.RequestState': requestParameters?.queryRequestState,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.Are': requestParameters?.queryAre,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.ReportingDate': requestParameters?.queryReportingDate,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.SeasonTitle': requestParameters?.querySeasonTitle,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.SubState': requestParameters?.querySubState,
        'Query.SearchString': requestParameters?.querySearchString
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getFieldValuesBySeasonRestructuringReporting(
    requestParameters?: GetFieldValuesBySeasonRestructuringReportingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public getFieldValuesBySeasonRestructuringReporting(
    requestParameters?: GetFieldValuesBySeasonRestructuringReportingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public getFieldValuesBySeasonRestructuringReporting(
    requestParameters?: GetFieldValuesBySeasonRestructuringReportingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public getFieldValuesBySeasonRestructuringReporting(
    requestParameters?: GetFieldValuesBySeasonRestructuringReportingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const fieldName = requestParameters?.fieldName;
    this.checkRequired('getFieldValuesBySeasonRestructuringReporting', { seasonId, fieldName });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/reporting/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Query.Attributes': requestParameters?.queryAttributes,
        'Query.AttributeByName': requestParameters?.queryAttributeByName,
        'Query.Assignments': requestParameters?.queryAssignments,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.RequestState': requestParameters?.queryRequestState,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.Are': requestParameters?.queryAre,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.ReportingDate': requestParameters?.queryReportingDate,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.SeasonTitle': requestParameters?.querySeasonTitle,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.SubState': requestParameters?.querySubState,
        'Query.SearchString': requestParameters?.querySearchString
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getHeadersRestructuringCommitment(
    requestParameters?: GetHeadersRestructuringCommitmentParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<RestructuringReportingHeader>>;
  public getHeadersRestructuringCommitment(
    requestParameters?: GetHeadersRestructuringCommitmentParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<RestructuringReportingHeader>>>;
  public getHeadersRestructuringCommitment(
    requestParameters?: GetHeadersRestructuringCommitmentParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<RestructuringReportingHeader>>>;
  public getHeadersRestructuringCommitment(
    requestParameters?: GetHeadersRestructuringCommitmentParams,
    ...args: RequestArgs
  ): Observable<any> {
    const countryCode = requestParameters?.countryCode;
    this.checkRequired('getHeadersRestructuringCommitment', { countryCode });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/commitment/headers/${this.configuration.encodeParam({ name: 'countryCode', value: countryCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getHeadersRestructuringReporting(
    requestParameters?: GetHeadersRestructuringReportingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<RestructuringReportingHeader>>;
  public getHeadersRestructuringReporting(
    requestParameters?: GetHeadersRestructuringReportingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<RestructuringReportingHeader>>>;
  public getHeadersRestructuringReporting(
    requestParameters?: GetHeadersRestructuringReportingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<RestructuringReportingHeader>>>;
  public getHeadersRestructuringReporting(
    requestParameters?: GetHeadersRestructuringReportingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const countryCode = requestParameters?.countryCode;
    this.checkRequired('getHeadersRestructuringReporting', { countryCode });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/reporting/headers/${this.configuration.encodeParam({ name: 'countryCode', value: countryCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getItemsByCountryRestructuringCommitment(
    requestParameters?: GetItemsByCountryRestructuringCommitmentParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRestructuringRequestReport>;
  public getItemsByCountryRestructuringCommitment(
    requestParameters?: GetItemsByCountryRestructuringCommitmentParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRestructuringRequestReport>>;
  public getItemsByCountryRestructuringCommitment(
    requestParameters?: GetItemsByCountryRestructuringCommitmentParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRestructuringRequestReport>>;
  public getItemsByCountryRestructuringCommitment(
    requestParameters?: GetItemsByCountryRestructuringCommitmentParams,
    ...args: RequestArgs
  ): Observable<any> {
    const countryCode = requestParameters?.countryCode;
    this.checkRequired('getItemsByCountryRestructuringCommitment', { countryCode });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/commitment/country/${this.configuration.encodeParam({ name: 'countryCode', value: countryCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Query.Attributes': requestParameters?.queryAttributes,
        'Query.AttributeByName': requestParameters?.queryAttributeByName,
        'Query.Assignments': requestParameters?.queryAssignments,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.RequestState': requestParameters?.queryRequestState,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.Are': requestParameters?.queryAre,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.ReportingDate': requestParameters?.queryReportingDate,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.SeasonTitle': requestParameters?.querySeasonTitle,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.SubState': requestParameters?.querySubState,
        'Query.SearchString': requestParameters?.querySearchString
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getItemsByCountryRestructuringReporting(
    requestParameters?: GetItemsByCountryRestructuringReportingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRestructuringRequestReport>;
  public getItemsByCountryRestructuringReporting(
    requestParameters?: GetItemsByCountryRestructuringReportingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRestructuringRequestReport>>;
  public getItemsByCountryRestructuringReporting(
    requestParameters?: GetItemsByCountryRestructuringReportingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRestructuringRequestReport>>;
  public getItemsByCountryRestructuringReporting(
    requestParameters?: GetItemsByCountryRestructuringReportingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const countryCode = requestParameters?.countryCode;
    this.checkRequired('getItemsByCountryRestructuringReporting', { countryCode });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/reporting/country/${this.configuration.encodeParam({ name: 'countryCode', value: countryCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Query.Attributes': requestParameters?.queryAttributes,
        'Query.AttributeByName': requestParameters?.queryAttributeByName,
        'Query.Assignments': requestParameters?.queryAssignments,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.RequestState': requestParameters?.queryRequestState,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.Are': requestParameters?.queryAre,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.ReportingDate': requestParameters?.queryReportingDate,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.SeasonTitle': requestParameters?.querySeasonTitle,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.SubState': requestParameters?.querySubState,
        'Query.SearchString': requestParameters?.querySearchString
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getItemsByRequestRestructuringCommitment(
    requestParameters?: GetItemsByRequestRestructuringCommitmentParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRestructuringRequestReport>;
  public getItemsByRequestRestructuringCommitment(
    requestParameters?: GetItemsByRequestRestructuringCommitmentParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRestructuringRequestReport>>;
  public getItemsByRequestRestructuringCommitment(
    requestParameters?: GetItemsByRequestRestructuringCommitmentParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRestructuringRequestReport>>;
  public getItemsByRequestRestructuringCommitment(
    requestParameters?: GetItemsByRequestRestructuringCommitmentParams,
    ...args: RequestArgs
  ): Observable<any> {
    const requestId = requestParameters?.requestId;
    this.checkRequired('getItemsByRequestRestructuringCommitment', { requestId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/commitment/requests/${this.configuration.encodeParam({ name: 'requestId', value: requestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Attributes': requestParameters?.queryAttributes,
        'Query.AttributeByName': requestParameters?.queryAttributeByName,
        'Query.Assignments': requestParameters?.queryAssignments,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.RequestState': requestParameters?.queryRequestState,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.Are': requestParameters?.queryAre,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.ReportingDate': requestParameters?.queryReportingDate,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.SeasonTitle': requestParameters?.querySeasonTitle,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.SubState': requestParameters?.querySubState,
        'Query.SearchString': requestParameters?.querySearchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getItemsByRequestRestructuringReporting(
    requestParameters?: GetItemsByRequestRestructuringReportingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRestructuringRequestReport>;
  public getItemsByRequestRestructuringReporting(
    requestParameters?: GetItemsByRequestRestructuringReportingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRestructuringRequestReport>>;
  public getItemsByRequestRestructuringReporting(
    requestParameters?: GetItemsByRequestRestructuringReportingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRestructuringRequestReport>>;
  public getItemsByRequestRestructuringReporting(
    requestParameters?: GetItemsByRequestRestructuringReportingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const requestId = requestParameters?.requestId;
    this.checkRequired('getItemsByRequestRestructuringReporting', { requestId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/reporting/requests/${this.configuration.encodeParam({ name: 'requestId', value: requestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Attributes': requestParameters?.queryAttributes,
        'Query.AttributeByName': requestParameters?.queryAttributeByName,
        'Query.Assignments': requestParameters?.queryAssignments,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.RequestState': requestParameters?.queryRequestState,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.Are': requestParameters?.queryAre,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.ReportingDate': requestParameters?.queryReportingDate,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.SeasonTitle': requestParameters?.querySeasonTitle,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.SubState': requestParameters?.querySubState,
        'Query.SearchString': requestParameters?.querySearchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getItemsBySeasonRestructuringCommitment(
    requestParameters?: GetItemsBySeasonRestructuringCommitmentParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRestructuringRequestReport>;
  public getItemsBySeasonRestructuringCommitment(
    requestParameters?: GetItemsBySeasonRestructuringCommitmentParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRestructuringRequestReport>>;
  public getItemsBySeasonRestructuringCommitment(
    requestParameters?: GetItemsBySeasonRestructuringCommitmentParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRestructuringRequestReport>>;
  public getItemsBySeasonRestructuringCommitment(
    requestParameters?: GetItemsBySeasonRestructuringCommitmentParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getItemsBySeasonRestructuringCommitment', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/commitment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Query.Attributes': requestParameters?.queryAttributes,
        'Query.AttributeByName': requestParameters?.queryAttributeByName,
        'Query.Assignments': requestParameters?.queryAssignments,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.RequestState': requestParameters?.queryRequestState,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.Are': requestParameters?.queryAre,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.ReportingDate': requestParameters?.queryReportingDate,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.SeasonTitle': requestParameters?.querySeasonTitle,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.SubState': requestParameters?.querySubState,
        'Query.SearchString': requestParameters?.querySearchString
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getItemsBySeasonRestructuringReporting(
    requestParameters?: GetItemsBySeasonRestructuringReportingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRestructuringRequestReport>;
  public getItemsBySeasonRestructuringReporting(
    requestParameters?: GetItemsBySeasonRestructuringReportingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRestructuringRequestReport>>;
  public getItemsBySeasonRestructuringReporting(
    requestParameters?: GetItemsBySeasonRestructuringReportingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRestructuringRequestReport>>;
  public getItemsBySeasonRestructuringReporting(
    requestParameters?: GetItemsBySeasonRestructuringReportingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getItemsBySeasonRestructuringReporting', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/reporting/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Query.Attributes': requestParameters?.queryAttributes,
        'Query.AttributeByName': requestParameters?.queryAttributeByName,
        'Query.Assignments': requestParameters?.queryAssignments,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.RequestState': requestParameters?.queryRequestState,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.Are': requestParameters?.queryAre,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.ReportingDate': requestParameters?.queryReportingDate,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.SeasonTitle': requestParameters?.querySeasonTitle,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.SubState': requestParameters?.querySubState,
        'Query.SearchString': requestParameters?.querySearchString
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRequestRestructuringRequest(
    requestParameters?: GetRequestRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RestructuringRequest>;
  public getRequestRestructuringRequest(
    requestParameters?: GetRequestRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RestructuringRequest>>;
  public getRequestRestructuringRequest(
    requestParameters?: GetRequestRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RestructuringRequest>>;
  public getRequestRestructuringRequest(
    requestParameters?: GetRequestRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    const requestId = requestParameters?.requestId;
    this.checkRequired('getRequestRestructuringRequest', { requestId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/requests/${this.configuration.encodeParam({ name: 'requestId', value: requestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryCommentsRestructuringRequest(
    requestParameters?: QueryCommentsRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRestructuringComment>;
  public queryCommentsRestructuringRequest(
    requestParameters?: QueryCommentsRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRestructuringComment>>;
  public queryCommentsRestructuringRequest(
    requestParameters?: QueryCommentsRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRestructuringComment>>;
  public queryCommentsRestructuringRequest(
    requestParameters?: QueryCommentsRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    const requestId = requestParameters?.requestId;
    this.checkRequired('queryCommentsRestructuringRequest', { requestId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/requests/${this.configuration.encodeParam({ name: 'requestId', value: requestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValueRestructuringRequest(
    requestParameters?: QueryFieldValueRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValueRestructuringRequest(
    requestParameters?: QueryFieldValueRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValueRestructuringRequest(
    requestParameters?: QueryFieldValueRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValueRestructuringRequest(
    requestParameters?: QueryFieldValueRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    const fieldName = requestParameters?.fieldName;
    this.checkRequired('queryFieldValueRestructuringRequest', { fieldName });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/requests/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        FiscalYear: requestParameters?.fiscalYear,
        'Query.Country': requestParameters?.queryCountry,
        'Query.Are': requestParameters?.queryAre,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.State': requestParameters?.queryState,
        'Query.LineManagerGid': requestParameters?.queryLineManagerGid,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.CompanyManagerGid': requestParameters?.queryCompanyManagerGid,
        'Query.CreatedByGid': requestParameters?.queryCreatedByGid,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValueWithIdRestructuringRequest(
    requestParameters?: QueryFieldValueWithIdRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfFieldItem>;
  public queryFieldValueWithIdRestructuringRequest(
    requestParameters?: QueryFieldValueWithIdRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfFieldItem>>;
  public queryFieldValueWithIdRestructuringRequest(
    requestParameters?: QueryFieldValueWithIdRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfFieldItem>>;
  public queryFieldValueWithIdRestructuringRequest(
    requestParameters?: QueryFieldValueWithIdRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    const fieldName = requestParameters?.fieldName;
    this.checkRequired('queryFieldValueWithIdRestructuringRequest', { fieldName });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/requests/field-values-with-id/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        FiscalYear: requestParameters?.fiscalYear,
        'Query.Country': requestParameters?.queryCountry,
        'Query.Are': requestParameters?.queryAre,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.State': requestParameters?.queryState,
        'Query.LineManagerGid': requestParameters?.queryLineManagerGid,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.CompanyManagerGid': requestParameters?.queryCompanyManagerGid,
        'Query.CreatedByGid': requestParameters?.queryCreatedByGid,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRestructuringRequest(
    requestParameters?: QueryRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRestructuringRequest>;
  public queryRestructuringRequest(
    requestParameters?: QueryRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRestructuringRequest>>;
  public queryRestructuringRequest(
    requestParameters?: QueryRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRestructuringRequest>>;
  public queryRestructuringRequest(
    requestParameters?: QueryRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/requests`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        FiscalYear: requestParameters?.fiscalYear,
        'Query.Country': requestParameters?.queryCountry,
        'Query.Are': requestParameters?.queryAre,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.PlanId': requestParameters?.queryPlanId,
        'Query.State': requestParameters?.queryState,
        'Query.LineManagerGid': requestParameters?.queryLineManagerGid,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.FiscalYear': requestParameters?.queryFiscalYear,
        'Query.CompanyManagerGid': requestParameters?.queryCompanyManagerGid,
        'Query.CreatedByGid': requestParameters?.queryCreatedByGid,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public restructuringCustomerQueryAttributes(
    requestParameters?: RestructuringCustomerQueryAttributesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public restructuringCustomerQueryAttributes(
    requestParameters?: RestructuringCustomerQueryAttributesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public restructuringCustomerQueryAttributes(
    requestParameters?: RestructuringCustomerQueryAttributesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public restructuringCustomerQueryAttributes(
    requestParameters?: RestructuringCustomerQueryAttributesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('restructuringCustomerQueryAttributes', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/attributes/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/values`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public restructuringCustomerQueryEmployeeSnapshots(
    requestParameters?: RestructuringCustomerQueryEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRestructuringEmployeeSnapshotLight>;
  public restructuringCustomerQueryEmployeeSnapshots(
    requestParameters?: RestructuringCustomerQueryEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRestructuringEmployeeSnapshotLight>>;
  public restructuringCustomerQueryEmployeeSnapshots(
    requestParameters?: RestructuringCustomerQueryEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRestructuringEmployeeSnapshotLight>>;
  public restructuringCustomerQueryEmployeeSnapshots(
    requestParameters?: RestructuringCustomerQueryEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/restructuring/customer/v1/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SearchString: requestParameters?.searchString,
        IncludeManagerInformation: requestParameters?.includeManagerInformation,
        IncludeAttributes: requestParameters?.includeAttributes,
        IncludeLetter: requestParameters?.includeLetter,
        'Query.Country': requestParameters?.queryCountry,
        'Query.LegalEntity': requestParameters?.queryLegalEntity,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FullName': requestParameters?.queryFullName,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.Attributes': requestParameters?.queryAttributes,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveCalculationRestructuringCalculation(
    requestParameters?: SaveCalculationRestructuringCalculationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RestructuringCalculation>;
  public saveCalculationRestructuringCalculation(
    requestParameters?: SaveCalculationRestructuringCalculationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RestructuringCalculation>>;
  public saveCalculationRestructuringCalculation(
    requestParameters?: SaveCalculationRestructuringCalculationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RestructuringCalculation>>;
  public saveCalculationRestructuringCalculation(
    requestParameters?: SaveCalculationRestructuringCalculationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/restructuring/customer/v1/calculation`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.saveRestructuringCalculation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateRequestRestructuringRequest(
    requestParameters?: UpdateRequestRestructuringRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RestructuringRequest>;
  public updateRequestRestructuringRequest(
    requestParameters?: UpdateRequestRestructuringRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RestructuringRequest>>;
  public updateRequestRestructuringRequest(
    requestParameters?: UpdateRequestRestructuringRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RestructuringRequest>>;
  public updateRequestRestructuringRequest(
    requestParameters?: UpdateRequestRestructuringRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/restructuring/customer/v1/requests`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateRestructuringRequest,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
